// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2WGT0","label":"SetPasswdForm_label__2F7F1"};